module.exports = __webpack_public_path__ + "static/media/Shellos_gaussian2.26a49dd5.png";